export const payloadShopifyDefault: any = {
  site_id: "",
  store_url: "https://verb-zyia-crm.myshopify.com",
  store_api_key: "bf70238ceeff4fd964335983541f49c4",
  store_type: "shopify",
  query: "",
  tag: "",
  last_item: "",
  shop_site_name: "",
};

export const payloadBrandDefault: any = {
  site_id: "",
  store_url: "https://verb-zyia-crm.myshopify.com",
  store_api_key: "bf70238ceeff4fd964335983541f49c4",
  store_type: "shopify",
};

export const payloadYoliShopify: any = {
  site_id: "",
  store_url: "https://verb-yoli-crm.myshopify.com",
  store_api_key: "182ed15e83085e14cbf8fa1d71a0c635",
  store_type: "shopify",
  query: "",
  tag: "",
  last_item: "",
  shop_site_name: "",
};

export const payloadYoliShopifyBrand: any = {
  site_id: "",
  store_url: "https://verb-yoli-crm.myshopify.com",
  store_api_key: "182ed15e83085e14cbf8fa1d71a0c635",
  store_type: "shopify",
};

export const payloadBeyondShopify: any = {
  site_id: "",
  store_url: "https://verb-beyondslim-crm.myshopify.com",
  store_api_key: "65b9d2851dd9435bfceb7da871e6e9d5",
  store_type: "shopify",
  query: "",
  tag: "",
  last_item: "",
  shop_site_name: "",
};

export const payloadBeyondShopifyBrand: any = {
  site_id: "",
  store_url: "https://verb-beyondslim-crm.myshopify.com",
  store_api_key: "65b9d2851dd9435bfceb7da871e6e9d5",
  store_type: "shopify",
};

export const payloadTranontShopify: any = 
{
  "site_id":"",
  "store_url":"https://646b29.myshopify.com",
  "store_api_key":"1ee949da5c29c21f0af6b8a1bc00c3eb",
  "store_type":"shopify",
  "query":"",
  "tag":"",
  "last_item":"",
  "shop_site_name":""
}

export const payloadTranontShopifyBrand: any = {
  "site_id":"",
  "store_url":"https://646b29.myshopify.com",
  "store_api_key":"1ee949da5c29c21f0af6b8a1bc00c3eb",
  "store_type":"shopify"
}

export const payloadSoundShopify: any = {
  "site_id":"",
  "store_url":"https://soundconcepts.myshopify.com",
  "store_api_key":"651b28203333874a8e5f20f91797478d",
  "store_type":"shopify"
}

export const payloadSoundShopifyBrand: any = {
  "site_id":"",
  "store_url":"https://soundconcepts.myshopify.com",
  "store_api_key":"651b28203333874a8e5f20f91797478d",
  "store_type":"shopify",
  "query":"","tag":"","last_item":"",
  "shop_site_name":""
}
